import {
  ComponentPropsWithRef,
  forwardRef,
  ForwardRefRenderFunction,
} from 'react';
import styles from './style.module.css';

export interface ISelectOption {
  value: string;
  label: string;
}

interface ISelect extends ComponentPropsWithRef<'select'> {
  name: string;
  options: ISelectOption[];
  placeholder?: string;
  errors?: string;
  label?: string | JSX.Element;
}

const SelectBase: ForwardRefRenderFunction<HTMLSelectElement, ISelect> = (
  { name, options, placeholder, errors, label, ...rest },
  ref
) => {
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <select
        className={styles.select}
        name={name}
        {...rest}
        id={name}
        ref={ref}
      >
        <option value="">{placeholder ?? 'Selecione'}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className={styles.error}>{errors}</span>
    </>
  );
};

export const Select = forwardRef(SelectBase);
